<template>
    <div class="minisite-modal-list">
        <template-00 v-if="data.style.templateId === '00'" :data="data"></template-00>
    </div>
</template>

<script>
    import ModalComponent from "./modal"

    export default {
        name: "ModalComponent",
        components: {
            "template-00": ModalComponent.Template00
        },
        props: {
            data: {}
        }
    }
</script>

<style lang="less" scoped>
    .minisite-modal-list {
        height: 0;
        overflow: visible;
    }
</style>
